import parsePhoneNumber, { AsYouType, isPossiblePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js/max'
import moment from 'moment';
import store from './store'
import { isPresent } from './baseUtils';
import C from './constants';

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
}

export const validator = (value, key, requiredFields) => {
  if (typeof key != 'string' || !key || !requiredFields[key]) { return null }
  let valid = false;
  const requiredValidations = requiredFields[key].validations
  const validationKeys = requiredValidations ? Object.keys(requiredValidations) : []

  const validateString = () => {
    let regexp = new RegExp(/^[\w\s\-\\,\/'àâçéèêëîïôûùüÿñæœ]{2,}$/);
    return regexp.test(value);
  }

  const validateBoolean = () => {
    return typeof value === 'boolean'
  }

  const validatePassword = () => {
    let regexp = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/);
    return regexp.test(value);
  }

  const validateName = () => {
    let regexp = new RegExp(/^[a-zA-Z \-\']{2,40}$/); //Letters only, no special characters, spaces permitted, 2-40 character length
    return regexp.test(value);
  }

  const validatePhone = () => {
    const { phone_country_code } = store.getState().territory
    const asYouType = new AsYouType(phone_country_code)

    asYouType.input(value)

    return asYouType.isValid()
  }

  const validatePresence = () => {
    if (!value) { return false }
    let present;
    switch (typeof value) {
      case 'string':
        present = isPresent(value)
        break
      case 'boolean':
        present = true
        break
      default:
        present = value && value.length > 0
        break
    }
    return present
  }

  const validatePlace = async () => {
    const { code } = store.getState().territory

    if (typeof value === 'object' && code === 'SRSC') {
      const { state, postcode } = value

      let formUrl = `/validate_address.json?state=${state}&postcode=${postcode}`;
      const response = await fetch(formUrl, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const data = await response.json();
      store.dispatch({
        type: C.SET_ADDRESS_VALIDATIONS,
        payload: data
      });
      return !!(data.postcode && data.state);
    }

    return isPresent(value)
  }

  const validateDate = () => {
    if (typeof value != 'string') { return null }
    if (value == null || value == '') { return false }
    const momentDate = moment(value)
    const maxDate = moment().add(3, 'years')
    let conditions = requiredValidations['date']
    let date = new Date(value)
    let latestDate = new Date(conditions.latest_date)
    let earliestDate = new Date(conditions.earliest_date)

    if (momentDate.isAfter(maxDate)) {
      $("#formgroup-dob").popover('show');
      return false
    } else if (earliestDate && date < earliestDate) {
      $("#formgroup-dob").popover('show');
      return false
    } else if (latestDate && date > latestDate) {
      $("#formgroup-dob").popover('show');
      return false
    } else {
      $("#formgroup-dob").popover('hide');
      return true
    }
  }

  const validateEmailFormat = () => {
    var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
    return regexp.test(value);
  }

  const validateEmailUnique = async () => {
    let formUrl = `/validate_email.json?email=${value}`;
    const response = await fetch(formUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    const data = await response.json();
    return data.valid;
  }

  if (validationKeys.length > 0) {
    // If any validation is async, the whole chain becomes async
    const hasAsync = validationKeys.some(k => ['email_unique', 'place'].includes(k));

    if (hasAsync) {
      return (async () => {
        for (let key of validationKeys) {
          switch (key) {
            case 'email_format': valid = validateEmailFormat(); break;
            case 'email_unique': valid = await validateEmailUnique(); break;
            case 'name': valid = validateName(); break;
            case 'phone': valid = validatePhone(); break;
            case 'attributes_user_dob':
            case 'date': valid = validateDate(); break;
            case 'string': valid = validateString(); break;
            case 'boolean': valid = validateBoolean(); break;
            case 'password': valid = validatePassword(); break;
            case 'place': valid = await validatePlace(); break;
            default: valid = false; break;
          }
          if (!valid) { break; }
        }
        return valid;
      })();
    } else {
      // Synchronous path
      for (let key of validationKeys) {
        switch (key) {
          case 'email_format': valid = validateEmailFormat(); break;
          case 'name': valid = validateName(); break;
          case 'phone': valid = validatePhone(); break;
          case 'attributes_user_dob':
          case 'date': valid = validateDate(); break;
          case 'string': valid = validateString(); break;
          case 'boolean': valid = validateBoolean(); break;
          case 'password': valid = validatePassword(); break;
          default: valid = false; break;
        }
        if (!valid) { break; }
      }
      return valid;
    }
  } else {
    return validatePresence();
  }
}

export const fieldsToValidate = (state) => {
  return (
    Object.keys(state).filter((key) => {
      return state[key] && typeof state[key] == 'object' && isPresent(state[key].validationKey)
    })
  )
}

export const pageValid = (state, requiredFields) => {
  let valid = true
  fieldsToValidate(state).forEach((field) => {
    let requiresValidation = typeof requiredFields[state[field].validationKey] == 'object'
    if (requiresValidation && state[field].valid != true) {
      valid = false
    }
  })
  return valid
}

export const executeValidations = async (component) => {
  let updates = {};
  const fields = fieldsToValidate(component.state);

  if (fields.length === 0 && component.props.onSkipSubmit && component.props.onGoBack) {
    const state = store.getState();
    const direction = state.navigationDirection;

    if (direction === 'backward') {
      component.props.onGoBack();
    } else {
      component.props.onSkipSubmit();
    }
    return;
  }

  for (const field of fields) {
    let valid = await validator(
      component.state[field].val,
      component.state[field].validationKey,
      component.props.requiredFields
    )
    let obj = component.state[field]
    obj.valid = valid
    updates[field] = obj
  }
  if (Object.keys(updates).length > 0) {
    component.setState(updates);
  }
}

export const shouldValidateProfileElement = (component, element) => {
  return component.props.activeProfileElements.includes(element)
}

export const toggleValidations = async (component, validationEnabled, dependentField, id, validationKey) => {
  if (dependentField) {
    validationEnabled = validationEnabled && shouldValidateProfileElement(component, dependentField)
  }
  let obj = component.state[id]
  obj.val = validationEnabled ? obj.val : ''
  obj.validationKey = validationEnabled ? validationKey : ''
  obj.valid = validationEnabled ? await validator(obj.val, validationKey, component.props.requiredFields) : ''
  component.setState({ [id]: obj });
}
